import { Box, Typography, Grid, ListItem, ListItemText, Divider, Link } from '@mui/material';
import useTranslation from 'assets/js/i18next';
import PropTypes from 'prop-types';
import { BrowserView, MobileView } from 'react-device-detect';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Logo from '../../assets/images/logo.png';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <>
            <Box sx={{ flexGrow: 1, mt: 9, mb: 5, zIndex: 3 }}>
                <Box container direction="row" alignItems="center" justifyContent="space-between" className="homeFooter" sx={{ mb: 2 }}>
                    <Box item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', p: 0 }}>
                        <Typography sx={{ color: '#2084DB', fontSize: '24px' }}>CONTACT</Typography>
                        <Typography sx={{ color: '#2084DB', fontSize: '18px', mb: 1 }}>お問い合わせ</Typography>
                        <Typography>土地·戸建・マンションから事業用物件まで幅広く誠意をもって対応させて頂きます。</Typography>
                    </Box>
                    <Box item sx={{ display: 'flex', pr: 5, ml: 1, alignItems: 'center' }}>
                        <Box className="homeFooterCard">
                            <Typography>電話番号</Typography>
                            <Typography>03-5826-8659</Typography>
                        </Box>
                        <a className="homeFooterCard" href="mailto:kaihatsu@ysd-japan.co.jp">
                            <Typography>メ一ルでのお問い合わせ</Typography>
                            <Typography>kaihatsu@ysd-japan.co.jp</Typography>
                        </a>
                    </Box>
                </Box>
                <Box container direction="row" alignItems="center" justifyContent="space-between" className="homeFooter">
                    <Box item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', p: 0 }}>
                        <Typography sx={{ fontSize: '24px', mb: 2 }}>株式会社Y.S.D</Typography>
                        <Typography>〒110-0016&nbsp;&nbsp;東京都台東区台東 1-24-9 ブライト秋葉原 5 階</Typography>
                        <Typography>Tel:03-5826-8659&nbsp;&nbsp;/&nbsp;&nbsp;Fax:03-5826-8657</Typography>
                        <Typography>営業時間 10:00~18:00&nbsp;&nbsp;/&nbsp;&nbsp;定休日 土曜日·日曜日·祝日</Typography>
                    </Box>
                    <Box item sx={{ textAlign: 'right', mr: 10, p: 0 }}>
                        <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <img src={Logo} alt="" style={{ height: '13px', marginRight: '10px' }} />
                            <Typography>株式会社Y.S.D</Typography>
                        </Typography>
                        <Typography>© 株式会社Y.S.D &nbsp;&nbsp; All Rights Reserved.</Typography>
                    </Box>
                </Box>
            </Box>
        </>
    );
};
export default Footer;
